export default __webpack_public_path__ + "static/media/cloud_storage.ace0658a.png";